import { navigationLinks } from '@/mocks/navigationLinks';

export default function HotLinks() {
  const officialLinks = navigationLinks['official-entry'] || [];
  const backupLinks = navigationLinks['backup-links'] || [];

  const allHot = [...officialLinks.slice(0, 2), ...backupLinks.filter((l) => l.status === 'online').slice(0, 3)];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门入口直达
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            以下入口当前全部可用，点击即可快速访问
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {allHot.map((link, index) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group no-underline"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 font-heading text-sm flex-shrink-0">
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {link.title}
                  </h3>
                  <span className={`flex-shrink-0 w-2 h-2 rounded-full ${
                    link.status === 'online' ? 'bg-accent-500' :
                    link.status === 'slow' ? 'bg-primary-400' : 'bg-foreground-400'
                  }`}></span>
                </div>
                <p className="text-xs text-foreground-500 truncate">
                  {link.description}
                  {link.speed && <span className="ml-2">· {link.speed}</span>}
                </p>
              </div>
              <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-external-link-line text-base"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}